import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=d73ef74e&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=d73ef74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73ef74e",
  null
  
)

export default component.exports